import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { useIcon } from "../../../hooks/useIcon/index.mjs";
import { IconChevronUpSvg } from "./IconChevronUpSvg.mjs";
const IconChevronUp = (props) => {
  const iconProps = useIcon(props);
  return /* @__PURE__ */ jsx(Box, { component: IconChevronUpSvg, ...iconProps });
};
export {
  IconChevronUp
};
